<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['view_inventory'] == 1">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                <div class="card" style="box-shadow: 0 0 5px gray;">
                  <div class="card-body">
                    <form @submit.prevent="AddtoCart">
                      <div class="form-group mb-2">
                        <label>Unit</label>
                        <multiselect
                          v-model="unit"
                          @input="FilterCategory"
                          label="name"
                          :options="inventoryunits"
                        ></multiselect>
                      </div>
                      <div class="form-group mb-2">
                        <label> Item</label>
                        <multiselect
                          v-model="inventoryitem"
                          label="name"
                          :options="inventoryitems"
                        ></multiselect>
                      </div>

                      <div class="form-group mb-2">
                        <label>Quantity</label>
                        <input
                          v-model="quantity"
                          type="number"
                          class="form-control"
                        />
                      </div>
                      <div class="form-group mb-2">
                        <label>Taken By</label>
                        <v-select
                          :options="users"
                          placeholder="Select User"
                          label="full_name"
                          v-model="user"
                          :reduce="(users) => users.id"
                        ></v-select>
                      </div>
                      <div class="form-group mb-2">
                        <label>Description</label>
                        <textarea
                          v-model="description"
                          type="text"
                          class="form-control"
                        />
                      </div>
                      <div class="form-group">
                        <button class="btn btn-primary w-100">
                          <i class="fas fa-check-circle"></i> Submit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div class="col-md-8">
                <div class="card" style="box-shadow: 0 0 2px gray;">
                  <span v-if="this.requisitioncarts.length <= 0">
                    <div class="d-flex justify-content-center p-5">
                      <span class="mdi mdi-cash text-success display-5"></span
                      ><br />
                      <span class="h4 mt-4">No Item Selected</span>
                    </div>
                  </span>
                  <span v-else>
                    <div class="table-responsive">
                      <b-table
                        :items="Items"
                        :fields="Fields"
                        responsive="sm"
                        :busy="IsBusy"
                      >
                        <template #table-busy
                          ><div class="text-center text-primary my-2">
                            <b-spinner
                              class="align-middle"
                              type="grow"
                              small
                            ></b-spinner>
                            <strong>No Data Found</strong>
                          </div></template
                        >
                        <template #cell(index)="data">
                          {{ data.index + 1 }}
                        </template>
                        <template #cell(expense)="data">
                          {{ data.item.expense.name }}
                        </template>
                        <template #cell(itemname)="data">
                          {{ data.item.item.name }}
                        </template>
                        <template #cell(unit)="data">
                          {{ data.item.unit.short_name }}
                        </template>
                        <template #cell(user)="data">
                          {{ data.item.users.full_name }}
                        </template>
                        <template #cell(itemnameid)="data">
                          {{ data.item.item.id }}
                        </template>
                        <template #cell(actions)="data">
                          <b-button
                            @click="remove(data.item.id, data.item.item.name)"
                            type="button"
                            class="btn-sm btn"
                            variant="danger"
                            v-b-modal.delete
                          >
                            <i class="mdi mdi-trash-can"></i>
                          </b-button>
                        </template>
                      </b-table>
                    </div>
                    <div class="row mx-1">
                      <!-- <div class="col-md-4">
                          <div class="form-group">
                            <label>Unit</label>
                            <input v-model="unit" type="number" readonly class="form-control" />
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label>Name</label>
                            <input v-model="itemname" type="text" readonly class="form-control" />
                          </div>
                        </div>
                      
                        <div class="col-md-4">
                          <div class="form-group">
                            <label>Quantity</label>
                            <input v-model="quantity" type="number" required class="form-control" />
                          </div>
                        </div> -->

                      <div class="col-md-4 mb-2">
                        <div class="form-group">
                          <label>Entry Date</label>
                          <input
                            v-model="paydate"
                            type="date"
                            required
                            class="form-control"
                          />
                        </div>
                      </div>
                      <div class="col-md-4"></div>
                      <div class="col-md-4">
                        <b-button
                          class="btn w-100 mt-4 mb-2"
                          @click="SubmitExit"
                          variant="primary"
                          ><i class="mdi mdi-check-circle"></i> SUBMIT &
                          EXIT</b-button
                        >
                      </div>
                    </div>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-modal
        id="delete-cart"
        centered
        title="Delete From Cart"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="removeFromCart">
          <input v-model="id" type="hidden" />
          Are you sure you want to remove the Item : <b>{{ itemname }}</b> ?
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('delete-cart')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view this Page.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Multiselect from "vue-multiselect";

import {
  requisitioncartMethods,
  requisitioncartComputed,
  inventoryUnitMethods,
  inventoryUnitComputed,
  userMethods,
  userComputed,
} from "@/state/helpers";

export default {
  page: {
    title: "Requisitions",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      title: "Add Requisiton",
      items: [
        { text: "Dashboard", href: "/" },
        { text: "Requsition", active: true },
      ],
      isBusy: true,

      userData: JSON.parse(localStorage.getItem("user")),
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "unit", label: "Unit", visible: true },
        { key: "itemname", label: " Name", visible: true },
        { key: "quantity", label: "Quantity", visible: true },
        // {key:  'user', label: 'Taken By', visible: true},
        { key: "description", label: "Description", visible: true },
        { key: "actions", label: "Remove", visible: true },
      ],
      id: "",
      expense: "",
      expenseitems: [],
      inventoryitems: [],
      // users:[],
      inventoryitem: "",
      unit: "",
      itemnameid: "",
      quantity: "",
      expenseitem: "",
      itemname: "",
      full_name: "",
      category: "",
      description: "",
      user: "",
      amount: "",
      paydate: new Date().toLocaleDateString("fr-CA"),
      payoption: "",
      amountpaid: "0",
    };
  },
  methods: {
    ...requisitioncartMethods,
    ...inventoryUnitMethods,
    ...userMethods,
    // ...paymentoptionMethods,
    async FilterCategory() {
      let url = `/findinventoryitems/${this.unit.id}`;
      await axios.get(url).then((response) => {
        this.inventoryitems = response.data.items;
      });
    },
    commas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    remove(id, itemname) {
      this.id = id;
      this.itemname = itemname;
      this.$bvModal.show("delete-cart");
    },
    async AddtoCart() {
      let formData = new FormData();
      formData.append("unit", this.unit.id);
      formData.append("item", this.inventoryitem.id);
      formData.append("quantity", this.quantity);
      formData.append("user", this.user);
      formData.append("description", this.description);
      let url = "/addordercart";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchRequisitionCart();
          this.unit = "";
          this.inventoryitem = "";
          this.quantity = "";
          this.user = "";
          this.description = "";
        }
      });
    },
    async removeFromCart() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/deleteordercart";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchRequisitionCart();
          this.$bvModal.hide("delete-cart");
        }
      });
    },
    async SubmitExit() {
      // let obj = {cart:this.Cart, amount:this.amountpaid, total:this.cart_total, payoption:this.payoption.id,paydate:this.paydate }
      let obj = {
        cart: this.Cart,
        quantity: this.quantity,
        unit: this.unit,
        itemname: this.itemname,
        recorddate: this.recorddate,
        user: this.user,
      };
      let url = "/saveordercart";
      await axios.post(url, obj).then((response) => {
        if (response.status == 200) {
          this.fetchRequisitionCart();
        }
      });
    },
  },
  computed: {
    ...requisitioncartComputed,
    ...inventoryUnitComputed,
    ...userComputed,
    // ...paymentoptionComputed,

    // cart_total(){ var total = 0; this.expensecarts.forEach((item)=>{ var item_total = item.amount; total = total+item_total;}); return total },
    List() {
      return this.requisitioncarts.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.requisitioncarts.map((d) => ({ ...d }));
    }, // Cart() { return this.requisitioncarts.map((d) => ({id:d.id,unit:d.unit.id,itemname:d.itemname,quantity:d.quantity,description:d.description }))},

    Cart() {
      return this.requisitioncarts.map((d) => ({
        id: d.id,
        unit: d.unit.id,
        itemname: d.item.id,
        quantity: d.quantity,
        description: d.description,
        user: d.user,
      }));
    },

    // Cart() { return this.requisitioncarts.map((d) => ({id:d.id,unit:d.unit.id,itemname:d.itemname,quantity:d.quantity,description:d.description }))},
    IsBusy() {
      let a = false;
      if (this.requisitioncarts.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
  },
  mounted() {
    this.fetchInventoryunits();
    this.fetchRequisitionCart();
    this.fetchUsers();
    // this.fetchPaymentoptions();
    this.isBusy = false;
    // this.payoption = this.paymentoptions.find(option => option.set_default == 1);
  },
};
</script>
